import React, { useState, useEffect } from 'react';
import { LinearProgress, Box, Typography, IconButton } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

import { supabase, host } from '../../supabaseClient';
import ResponsiveGallery from 'react-responsive-gallery';

import { useCode } from '../../contexts/Code';

const Gallery = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const { code } = useCode();

  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);

  const getGallery = async () => {
    setLoading(true);

    const { data, error } = await supabase.storage.from('photos').list(code, {
      limit: 3,
      offset: offset,
      sortBy: {
        column: 'created_at',
        order: 'desc',
      },
    });

    setLoading(false);

    if (error) return console.log(error);

    const prefix = host + '/storage/v1/object/public/photos/' + code + '/';
    const urls = data.map((item) => prefix + item.name);

    const galleryItems = urls.map((image, index) => ({
      src: image,
      alt: `image ${index + 1} alt test`,
    }));


    setGalleryItems(galleryItems);
  };

  const handlePrevClick = () => {
    if (offset >= 3) {
      setOffset(offset - 3);
    }
  };

  const handleNextClick = () => {
    setOffset(offset + 3);
  };

  useEffect(() => {
    getGallery();
  }, [offset]);

  if (galleryItems?.length == 0) return <></>

  if (!code) return

  return (
    <>
      <Typography color="white">{code == 45 ? 'Latest photos' : 'Últimas fotos'}</Typography>
      {loading && <LinearProgress />}
      <div className='gallery'>

        <ResponsiveGallery
          numOfImagesPerRow={{ xs: 3, s: 3, m: 3, l: 3, xl: 4, xxl: 5 }}
          customLoader={<></>}
          useLightBox
          images={galleryItems}
          customError={<></>}
          />
        </div>
      <Box display="flex" justifyContent="center" marginTop={2}>
        <IconButton onClick={handlePrevClick} disabled={offset === 0}>
          <ArrowBack />
        </IconButton>
        <IconButton onClick={handleNextClick}>
          <ArrowForward />
        </IconButton>
      </Box>
    </>
  );
};

export default Gallery;
